import React from "react";

const PrivacyStatement = () => (
    <div class="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8 mt-10">
        <h1 class="text-3xl font-bold text-blue-600 mb-4">Privacy Policy</h1>
        <p class="text-gray-600"><strong>Effective Date:</strong> 14-11-2025</p>

        <p class="mt-4">Welcome to <strong>college-avenue.com</strong> ("we," "our," "us"). Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information.</p>

        <h2 class="text-2xl font-semibold text-blue-500 mt-6">1. Information We Collect</h2>
        <ul class="list-disc list-inside mt-2 space-y-2">
            <li><strong>Personal Information:</strong> Name, email, phone number (collected when you contact us).</li>
            <li><strong>Usage Data:</strong> IP address, browser type, pages visited, and interactions with our site.</li>
            <li><strong>Cookies & Tracking:</strong> We use cookies to enhance user experience and track website analytics.</li>
        </ul>

        <h2 class="text-2xl font-semibold text-blue-500 mt-6">2. How We Use Your Information</h2>
        <ul class="list-disc list-inside mt-2 space-y-2">
            <li>To improve our services and provide relevant admission updates.</li>
            <li>To personalize content and offer tailored college insights.</li>
            <li>To analyze traffic and enhance website functionality.</li>
            <li>To comply with legal requirements and prevent fraud.</li>
        </ul>

        <h2 class="text-2xl font-semibold text-blue-500 mt-6">3. Sharing Your Information</h2>
        <p class="mt-2">We do not sell or rent your personal data. However, we may share non-personal data with:</p>
        <ul class="list-disc list-inside mt-2 space-y-2">
            <li><strong>Service Providers:</strong> Third-party tools that help us operate the website.</li>
            <li><strong>Legal Compliance:</strong> If required by law, we may share information with authorities.</li>
        </ul>

        <h2 class="text-2xl font-semibold text-blue-500 mt-6">4. Cookies & Tracking</h2>
        <p class="mt-2">We use cookies to enhance your experience. You can disable them in your browser settings, but this may affect site functionality.</p>

        <h2 class="text-2xl font-semibold text-blue-500 mt-6">5. Your Rights & Choices</h2>
        <p class="mt-2">You have the right to:</p>
        <ul class="list-disc list-inside mt-2 space-y-2">
            <li>Request details on how your data is used.</li>
        </ul>

        <h2 class="text-2xl font-semibold text-blue-500 mt-6">6. Updates to This Policy</h2>
        <p class="mt-2">We may update this Privacy Policy from time to time. Any changes will be posted here with the updated date.</p>
        <p class="mt-2">Last updated: 14-11-2025</p>
        <p class="mt-2">We collect IP addresses for security, analytics, and prevention of misuse.</p>
        
        <h2 class="text-2xl font-semibold text-blue-500 mt-6">7. Contact Us</h2>
        <p class="mt-2">If you have any questions, reach out to us at:</p>
        <p class="font-medium mt-2">📧 Email: <a href="mailto:administrator@college-avenue.com" class="text-blue-600 hover:underline">administrator@college-avenue.com</a></p>
        
        <p class="text-center text-gray-500 text-sm mt-6">© www.college-avenue.com | All rights reserved.</p>
    </div>
);

const TermsConditions = () => (
        <div class="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8 mt-10">
        <h1 class="text-3xl font-bold text-blue-600 mb-4">Terms & Conditions</h1>
        <p class="text-gray-600"><strong>Effective Date:</strong> 10-june-2025</p>

        <p class="mt-4">Welcome to <strong>[Your Website Name]</strong> ("we," "our," "us"). By using our website, you agree to these terms and conditions. Please read them carefully.</p>

        <h2 class="text-2xl font-semibold text-blue-500 mt-6">1. Acceptance of Terms</h2>
        <p class="mt-2">By accessing and using our website, you agree to be bound by these Terms and Conditions, along with our Privacy Policy.</p>

        <h2 class="text-2xl font-semibold text-blue-500 mt-6">2. Use of Our Website</h2>
        <ul class="list-disc list-inside mt-2 space-y-2">
            <li>You must be at least 13 years old to use this site.</li>
            <li>Do not misuse our services or engage in illegal activities on our platform.</li>
            <li>We reserve the right to suspend or terminate access if users violate these terms.</li>
        </ul>

        <h2 class="text-2xl font-semibold text-blue-500 mt-6">3. User Accounts</h2>
        <ul class="list-disc list-inside mt-2 space-y-2">
            <li>You are responsible for maintaining the confidentiality of your account.</li>
            <li>All activities under your account are your responsibility.</li>
        </ul>

        {/* <h2 class="text-2xl font-semibold text-blue-500 mt-6">4. Intellectual Property</h2> */}
        {/* <p class="mt-2">All content, including text, graphics, and software, is the property of [Your Website Name] and is protected by copyright laws.</p> */}

        <h2 class="text-2xl font-semibold text-blue-500 mt-6">5. Limitation of Liability</h2>
        <p class="mt-2">We aggregate notices and information freely available on the board sites simply to make them all available in one place. 
            However, we are not responsible for any direct, indirect, incidental, or consequential 
            damages resulting from the use of our website. Students are encouraged to visit the 
            authentic board sites for confirmation and clarity</p>

        <h2 class="text-2xl font-semibold text-blue-500 mt-6">6. Changes to These Terms</h2>
        <p class="mt-2">We may update these Terms and Conditions at any time. Continued use of our site means acceptance of the revised terms.</p>

        <h2 class="text-2xl font-semibold text-blue-500 mt-6">7. Contact Us</h2>
        <p class="mt-2">If you have any questions about these Terms, contact us at:</p>
        <p class="font-medium mt-2">📧 Email: <a href="mailto:administrator@college-avenue.com" class="text-blue-600 hover:underline">administrator@college-avenue.com</a></p>
        
        <p class="text-center text-gray-500 text-sm mt-6">© www.college-avenue.com | All rights reserved.</p>
    </div>
);
    
export { PrivacyStatement, TermsConditions };